import React, { FC, useMemo } from "react";
import AppointmentCard from "./AppointmentCard";
import GroupedAppointmentCard from "./GroupedAppointmentCard";
import { IAppointmentDetails } from "../../services/appointment-list/appointment-list.interface";
import { groupAppointments } from "../../utils/group-appointments/groupAppointments";

interface IAppointmentCardList {
  appointments: IAppointmentDetails[];
  className?: string;
}

const AppointmentCardList: FC<IAppointmentCardList> = (props) => {
  const grouped = useMemo(() => groupAppointments(props.appointments), [props.appointments]);

  return (
    <div className={`${props.className}`}>
      {
        grouped.map((group) => {
          if (group.appointments.length === 1) {
            const appointment = group.appointments[0];
            return <AppointmentCard key={appointment.id} visit={appointment} isMenu={true}/>;
          }
          const groupKey = group.appointments.map((a) => a.id).join("-");
          return <GroupedAppointmentCard key={groupKey} group={group} isMenu={true}/>;
        })
      }
    </div>
  );
};

export default AppointmentCardList;
